import $ from 'jquery';

function initAccountInfo() {
  const fields = document.querySelectorAll('.cf-field');

  [].forEach.call(fields, (field) => {
    const label = field.querySelector('label');
    const input = field.querySelector('input');

    $(input).on('keyup', () => {
      input.onblur = function () {
        label.classList.remove('active');
      };

      input.onfocus = function () {
        label.classList.add('active');
      };

      if ($(input).val() === '') {
        label.classList.add('empty-field');
      } else {
        label.classList.remove('empty-field');
      }
    });
  });
}

if (document.body.classList.contains('template-account')) {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(initAccountInfo, 3000);
  });
}
